import apiUserService from '@/services/api/common/userService';

export default {
  async init({ commit }) {
    try {
      const userIDPResponse = await apiUserService.getCurrent();
      commit('setInitialized', true);
      if (userIDPResponse) {
        commit('setUser', {
          parent_name: userIDPResponse.destination_name,
          ...userIDPResponse,
        });
        commit('setDestination', {
          id: userIDPResponse.parent_id,
          name: userIDPResponse.destination_name,
        });
        if (userIDPResponse.is_remote_raccourci) {
          const scr = document.createElement('script');
          if (window.location.host === 'user.studio.rc-preprod.com') {
            scr.src = 'https://connect.studio.rc-check.com/oauth/v2/logout?redirect=/';
          } else {
            scr.src = 'https://connect.studio.raccourci.fr/oauth/v2/logout?redirect=/';
          }
          document.body.appendChild(scr);
        }
      }
    } catch (e) {
      throw e;
    }
  },
};
